/* HHS Product page interactivity — vanilla, scoped to .hhs-product-wrap */
(function () {
  'use strict';

  /* ─── Variant card → form sync ─── */
  function initVariantSync(root) {
    var sec = root.querySelector('[id^="hhs-prod-"]');
    if (!sec) return;
    var sectionId = sec.id.replace('hhs-prod-', '');
    var jsonEl = document.getElementById('hhs-variants-' + sectionId);
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent || '[]'); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    var form     = sec.querySelector('form.hhs-form');
    var hiddenId = sec.querySelector('#hhs-variant-id-' + sectionId);
    var priceEl  = sec.querySelector('#prod-price-' + sectionId);
    var atcTxt   = sec.querySelector('#atc-txt-' + sectionId);
    var atcBtn   = sec.querySelector('#prod-atc-' + sectionId);
    var lbl      = sec.querySelector('#surf-lbl-' + sectionId);
    var mainImg  = sec.querySelector('#main-img-' + sectionId);
    var cards    = sec.querySelectorAll('.surface-card');

    function moneyFormat(cents) {
      // Lightweight USD fallback — Shopify-localized formats are
      // already rendered in card data-price; we only fall back to this
      // when no data-price was set.
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD', minimumFractionDigits: 0 }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(0); }
    }

    function selectByVariantId(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;

      // form id
      if (hiddenId) hiddenId.value = v.id;

      // pills
      cards.forEach(function (c) {
        var isSel = String(c.dataset.variantId) === String(v.id);
        c.classList.toggle('sel', isSel);
        var inp = c.querySelector('input.sr');
        if (inp) inp.checked = isSel;
      });

      // price
      var priceStr = (function () {
        var match = sec.querySelector('.surface-card[data-variant-id="' + v.id + '"]');
        if (match && match.dataset.price) return match.dataset.price;
        return moneyFormat(v.price);
      })();
      if (priceEl) priceEl.textContent = priceStr;

      // ATC label
      if (atcTxt) {
        var base = atcBtn && atcBtn.dataset && atcBtn.dataset.baseText
          ? atcBtn.dataset.baseText
          : (atcTxt.dataset && atcTxt.dataset.baseText) || (atcTxt.textContent.split(' — ')[0] || 'Add to Cart');
        atcTxt.dataset.baseText = base;
        atcTxt.textContent = v.available ? (base + ' — ' + priceStr) : 'Sold out';
      }

      // ATC disabled state
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
        }
      }

      // selected option label
      if (lbl) lbl.textContent = v.title || '';

      // featured image
      if (mainImg) {
        var card = sec.querySelector('.surface-card[data-variant-id="' + v.id + '"]');
        var imgUrl = card && card.dataset && card.dataset.image;
        if (imgUrl) {
          mainImg.src = imgUrl;
          mainImg.alt = (v.title || '') + ' — ' + (mainImg.dataset.baseAlt || '');
          // mark matching thumb if any
          var thumbs = sec.querySelectorAll('.gallery-thumb');
          thumbs.forEach(function (t) {
            var match = t.dataset.src === imgUrl;
            t.classList.toggle('act', match);
            t.setAttribute('aria-pressed', match ? 'true' : 'false');
          });
        }
      }

      // update URL with variant param (Shopify behaviour parity, no full reload)
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    cards.forEach(function (c) {
      if (c.dataset.bound === '1') return; // idempotent — survive shopify:section:load
      c.dataset.bound = '1';
      c.addEventListener('click', function (e) {
        // ignore clicks on the unavailable / disabled card
        if (c.classList.contains('unavailable')) { e.preventDefault(); return; }
        selectByVariantId(c.dataset.variantId);
      });
      var inp = c.querySelector('input.sr');
      if (inp) {
        inp.addEventListener('change', function () {
          if (inp.checked) selectByVariantId(c.dataset.variantId);
        });
      }
    });
  }

  /* ─── Gallery: prev/next/thumb/zoom ─── */
  function initGallery(root) {
    var main = root.querySelector('[id^="gallery-main-"]');
    if (!main || main.dataset.bound === '1') return;
    main.dataset.bound = '1';
    var sectionId = main.id.replace('gallery-main-', '');
    var img = main.querySelector('img');
    var thumbs = Array.from(root.querySelectorAll('.gallery-thumb'));
    var prevBtn = main.querySelector('[data-g-prev]');
    var nextBtn = main.querySelector('[data-g-next]');
    var zoomBtn = main.querySelector('[data-g-zoom]');

    if (img && !img.dataset.baseAlt) img.dataset.baseAlt = img.alt || '';

    function setIdx(i) {
      if (!thumbs.length) return;
      i = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      if (!t) return;
      var src = t.dataset.src;
      if (img && src) img.src = src;
      thumbs.forEach(function (x) { x.classList.remove('act'); x.setAttribute('aria-pressed', 'false'); });
      t.classList.add('act');
      t.setAttribute('aria-pressed', 'true');
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setIdx(i); });
    });

    function getActiveIdx() {
      var idx = thumbs.findIndex(function (x) { return x.classList.contains('act'); });
      return idx < 0 ? 0 : idx;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { setIdx(getActiveIdx() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setIdx(getActiveIdx() + 1); });

    if (zoomBtn && img) {
      zoomBtn.addEventListener('click', function () { openLightbox(img.src, img.alt); });
    }
  }

  /* ─── Lightbox ─── */
  var lb;
  function openLightbox(src, alt) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'hhs-lb';
      lb.innerHTML =
        '<button class="hhs-lb-close" type="button" aria-label="Close">✕</button>' +
        '<img class="hhs-lb-img" alt="">';
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('hhs-lb-close')) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lb && lb.classList.contains('open')) closeLightbox();
      });
      var style = document.createElement('style');
      style.textContent =
        '.hhs-lb{position:fixed;inset:0;z-index:800;background:rgba(0,0,0,.93);display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity .25s}' +
        '.hhs-lb.open{opacity:1;pointer-events:auto}' +
        '.hhs-lb-img{max-width:90vw;max-height:90svh;object-fit:contain;border-radius:8px;display:block}' +
        '.hhs-lb-close{position:absolute;top:1rem;right:1rem;width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:#fff;cursor:pointer;font-size:1.1rem}';
      document.head.appendChild(style);
      document.body.appendChild(lb);
    }
    var imgEl = lb.querySelector('.hhs-lb-img');
    imgEl.src = src;
    imgEl.alt = alt || '';
    lb.classList.add('open');
  }
  function closeLightbox() { if (lb) lb.classList.remove('open'); }

  /* ─── Quantity stepper ─── */
  function initQty(root) {
    root.querySelectorAll('[id^="qty-val-"]').forEach(function (inp) {
      var grp = inp.closest('.qty-ctrl');
      if (!grp || grp.dataset.bound === '1') return;
      grp.dataset.bound = '1';
      var minus = grp.querySelector('[data-qty-minus]');
      var plus  = grp.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) || 1;
        inp.value = Math.max(1, v - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) || 1;
        inp.value = v + 1;
      });
    });
  }

  /* ─── Accordion (single-open allowed) ─── */
  function initAccordion(root) {
    root.querySelectorAll('.acc-btn').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var grp = btn.closest('.acc-group');
        if (!grp) return;
        var opened = grp.classList.toggle('open');
        btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
      });
    });
  }

  /* ─── In Your Space style tabs ─── */
  function initStyleTabs(root) {
    document.querySelectorAll('.rmk-inspace-section .style-tabs').forEach(function (grp) {
      if (grp.dataset.bound === '1') return;
      grp.dataset.bound = '1';
      grp.querySelectorAll('.style-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grp.querySelectorAll('.style-tab.act').forEach(function (x) { x.classList.remove('act'); });
          btn.classList.add('act');
        });
      });
    });
  }

  /* ─── Size guide table hover → preview frame scale ─── */
  function initSizeGuide(root) {
    document.querySelectorAll('.rmk-sizeguide-section .size-guide-sec').forEach(function (sec) {
      if (sec.dataset.bound === '1') return;
      var rows  = sec.querySelectorAll('.size-table tbody tr');
      var frame = sec.querySelector('.size-viz-frame');
      var lbl   = sec.querySelector('.size-viz-lbl');
      if (!rows.length || !frame) return;
      sec.dataset.bound = '1';
      rows.forEach(function (tr) {
        tr.addEventListener('mouseenter', function () {
          var w = tr.dataset.w || 90;
          var h = tr.dataset.h || 90;
          frame.style.width  = w + 'px';
          frame.style.height = h + 'px';
          var sizeCell = tr.querySelector('td');
          if (sizeCell && lbl) lbl.textContent = (sizeCell.textContent || '').trim().replace(/\s+XL$/, '');
        });
      });
    });
  }

  /* ─── Reveal scan: stamp `.fu` elements to visible on init ─── */
  function reveal(root) {
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('vis');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.06 });
      root.querySelectorAll('.fu:not(.vis)').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.fu:not(.vis)').forEach(function (el) { el.classList.add('vis'); });
    }
  }

  function initAll(root) {
    root = root || document;
    initVariantSync(root);
    initGallery(root);
    initQty(root);
    initAccordion(root);
    initStyleTabs(root);
    initSizeGuide(root);
    reveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init on Shopify section re-renders in theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
})();
